import axios from 'axios';

// Conta as requisicoes da API em andamento para a barra de carregamento do topo.
let pending = 0;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(pending));

export function startRequest() {
  pending += 1;
  notify();
}

export function endRequest() {
  pending = Math.max(0, pending - 1);
  notify();
}

export function getPendingRequests() {
  return pending;
}

export function subscribeRequests(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Liga o contador a uma instancia do axios envolvendo o adapter (quem faz a chamada de rede).
// Nao usa interceptor de request: a API proibe interceptor de request (ver api.test.js).
// A resposta e o erro passam intactos.
export function trackRequests(instance) {
  const send = axios.getAdapter(instance.defaults.adapter);
  instance.defaults.adapter = (config) => {
    startRequest();
    return send(config).finally(endRequest);
  };
}

export function resetRequestsForTest() {
  pending = 0;
  listeners.clear();
}
